import React from 'react';
import { recordStats } from '../data/site';
export function StatsBand() {
  return <section className="bg-parchment py-24" data-id="element-264" data-mp="21bfwlr0vfn1k">
      <div className="mx-auto max-w-[1240px] px-6" data-id="element-265" data-mp="219lcug1c60z2">
        <p className="eyebrow text-green-dark" data-id="element-266" data-mp="1wbtizgh4s4s8">By The Numbers</p>
        <h2 className="mt-5 max-w-2xl font-display text-[34px] font-medium leading-[1.15] tracking-[-0.01em] text-ink sm:text-[42px]" data-id="element-267" data-mp="1w9yzm6lickq9">
          A decade of practice, on the record.
        </h2>

        <dl className="mt-12 grid border-l border-t border-line bg-paper sm:grid-cols-2 lg:grid-cols-4" data-id="element-268" data-mp="2ozz444c3jvsl">
          {recordStats.map(stat => <div key={stat.label} className="border-b border-r border-line px-8 py-12" data-id="element-269" data-mp="2f21h1k5z451k">
              <dt className="sr-only" data-id="element-270" data-mp="2a3q779fohujc">{stat.label}</dt>
              <dd data-id="element-271" data-mp="2a3853w6c4m3i">
                <span className="block font-display text-[46px] leading-none text-green-dark" data-id="element-272" data-mp="2a5u9xo1ucni1">
                  {stat.value}
                </span>
                <span className="mt-4 block font-mono text-[10px] uppercase tracking-[0.12em] text-ink-50" data-id="element-273" data-mp="yn9o964x0vrq">
                  {stat.label}
                </span>
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}